var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightModeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.527,
    height: 18.499,
    viewBox: "0 0 17.527 18.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightModeIcon",
    transform: "translate(-5647.5 53.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    "data-name": "Path 11264",
    d: "M12,4.944V3",
    transform: "translate(5643.777 -56)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    "data-name": "Path 11263",
    d: "M11.917,11.917,9,11.917A2.917,2.917,0,1,0,11.917,9,2.917,2.917,0,0,0,9,11.917",
    transform: "translate(5643.861 -56.167)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M17,6.961,18.361,5.6",
    transform: "translate(5643.638 -56.072)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    "data-name": "Path 11266",
    d: "M19,12h1.944",
    transform: "translate(5643.583 -56.25)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11270",
    "data-name": "Path 11270",
    d: "M5.944,12H4",
    transform: "translate(5644 -56.25)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    "data-name": "Path 11271",
    d: "M6.961,6.961,5.6,5.6",
    transform: "translate(5643.956 -56.072)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    "data-name": "Path 11267",
    d: "M17,17l1.361,1.361",
    transform: "translate(5643.638 -56.389)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    "data-name": "Path 11268",
    d: "M12,19v1.944",
    transform: "translate(5643.777 -56.445)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11269",
    "data-name": "Path 11269",
    d: "M6.961,17,5.6,18.361",
    transform: "translate(5643.956 -56.389)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeIcon);
export default __webpack_public_path__ + "static/media/lightModeIcon.940e67c53f065618b52f8c528fe58dbb.svg";
export { ForwardRef as ReactComponent };